import { Link } from "react-router-dom";
import { COMPANY, NAV } from "@/content/site";
import { Logo } from "./Logo";
import { useGoTo } from "./Header";

const LEGAL = [
  { to: "/aviso-legal", label: "Aviso legal" },
  { to: "/privacidad", label: "Política de privacidad" },
  { to: "/cookies", label: "Política de cookies" },
];

const ColTitle = ({ children }) => <h2 className="eyebrow mb-5 text-[#C9A66B]">{children}</h2>;

export default function Footer() {
  const goTo = useGoTo();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#16191E] pb-24 pt-20 text-white md:pb-10">
      <div className="container-x">
        <div className="grid gap-12 border-b border-white/10 pb-14 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo light />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/75">{COMPANY.shortDescription}</p>
          </div>
          <div className="lg:col-span-2">
            <ColTitle>Navegación</ColTitle>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}><a href={`/#${n.id}`} data-testid={`footer-nav-${n.id}`} onClick={(e) => { e.preventDefault(); goTo(n.id); }} className="link-underline text-sm text-white/80 hover:text-white">{n.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <ColTitle>Contacto</ColTitle>
            <ul className="space-y-3 text-sm">
              <li><a data-testid="footer-phone-link" href={COMPANY.phoneHref} className="link-underline text-white/80 hover:text-white">{COMPANY.phone}</a></li>
              <li><a data-testid="footer-email-link" href={COMPANY.emailHref} className="link-underline break-all text-white/80 hover:text-white">{COMPANY.email}</a></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <ColTitle>Legal</ColTitle>
            <ul className="space-y-3">
              {LEGAL.map((l) => (
                <li key={l.to}><Link data-testid={`footer-legal-${l.to.slice(1)}`} to={l.to} className="link-underline text-sm text-white/80 hover:text-white">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-3 pt-8 text-xs text-white/60 sm:flex-row sm:justify-between">
          <p data-testid="footer-copyright">© {year} {COMPANY.legalName} · NIF {COMPANY.taxId}. Todos los derechos reservados.</p>
          <p>Algunas imágenes de servicios son ilustrativas y están identificadas como tales.</p>
        </div>
      </div>
    </footer>
  );
}
